/**
 * @desc 修改生产计划设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.SettingPlanUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/setting/plan/update',
    data,
  });
}

export function mock(
  data: defs.SettingPlanUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/setting/plan/update',
    data,
  });
}
